// @flow
/** @jsx jsx */
import { css, jsx } from '@emotion/core';

import { Dropdown } from '@zapier/design-system';
import {
  type PaymentSourceMethod,
  type SupportedPaymentMethod,
  paymentSourceMethods,
} from '@zapier/payment/src/types';

type Props = {
  currentMethod?: PaymentSourceMethod,
  onChange: (method: PaymentSourceMethod) => void,
  supportedMethods: Array<SupportedPaymentMethod>,
};

const methodItems = {
  [paymentSourceMethods.card]: {
    label: 'Debit or Credit Card',
    value: paymentSourceMethods.card,
  },
  [paymentSourceMethods.paypal]: {
    label: 'PayPal',
    value: paymentSourceMethods.paypal,
  },
  [paymentSourceMethods.bank]: {
    label: 'Bank Transfer (US Only)',
    value: paymentSourceMethods.bank,
  },
};

const rootCss = css`
  min-width: 180px;
`;

const PaymentMethodSelect = ({
  currentMethod,
  onChange,
  supportedMethods = [],
}: Props) => {
  return (
    <div css={rootCss}>
      <Dropdown
        items={supportedMethods
          .map(m => methodItems[m.method])
          .filter(m => m.value !== currentMethod)}
        menuAriaLabel="List of supported payment methods"
        onChange={item => onChange(item.value)}
        placeholder={`${currentMethod ? 'Switch' : 'Add'} Payment Method`}
      />
    </div>
  );
};

export default PaymentMethodSelect;
